import React from 'react';

/**
 * Hayat Design System - Button Component
 * Phase 15.1 + 15.3 (Motion)
 * 
 * Variants: primary, secondary, muted, danger, ghost
 * Sizes: sm, md, lg
 * Phase 15.3: Added micro-animations (press, glow, hover)
 */

const Button = React.forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  disabled = false,
  className = '',
  ...props 
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-hayat-sm transition-all duration-200 ease-spring-soft focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.97] transform';
  
  const variantStyles = {
    primary: 'bg-hayat-primary-500 hover:bg-hayat-primary-600 hover:scale-105 text-white focus:ring-hayat-primary-500 shadow-hayat-sm hover:shadow-hayat-lg active:shadow-hayat-sm',
    secondary: 'bg-hayat-secondary-500 hover:bg-hayat-secondary-600 hover:scale-105 text-white focus:ring-hayat-secondary-500 shadow-hayat-sm hover:shadow-hayat-lg active:shadow-hayat-sm',
    muted: 'bg-hayat-neutral-100 hover:bg-hayat-neutral-200 hover:scale-105 text-hayat-neutral-800 focus:ring-hayat-neutral-400',
    danger: 'bg-hayat-danger-500 hover:bg-hayat-danger-600 hover:scale-105 text-white focus:ring-hayat-danger-500 shadow-hayat-sm hover:shadow-hayat-lg active:shadow-hayat-sm',
    ghost: 'bg-transparent hover:bg-hayat-neutral-100 hover:scale-105 text-hayat-neutral-700 focus:ring-hayat-neutral-400',
  };
  
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };
  
  return (
    <button
      ref={ref}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;